import { validate } from './validate';

document.addEventListener('DOMContentLoaded', function () {
  // Validate the form
  validate(document.getElementById('address_edit'), {
    rules: {
      // shippingAddressId: ['required'],
      searchAddress: [['requiredIfAll', [['useAddressFinder', '1']]]],
      fullName: ['required'],
      'fields[addressType]': ['required'],
      countryCode: ['required'],
      addressLine1: ['required'],
      locality: ['required'],
      administrativeArea: [['requiredIf', 'countryCode', 'AU']],
      postalCode: ['required', ['postcodeIfAu', 'countryCode']],
      'fields[phone]': ['phoneNumber'],
    },
  });
});
